import {useState} from "../../__snowpack__/pkg/react.js";
import {createModel} from "../../__snowpack__/pkg/hox.js";
import {axios} from "../lib/axios.js";
import {handleError} from "../lib/errorHandler.js";
export const useCategories = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [CategoriesList, setCategoriesList] = useState([]);
  const fetchData = async (channelId, countryCode, shopId) => {
    try {
      setIsLoading(true);
      let result;
      switch (channelId) {
        case "WOO_COMMERCE_ID":
          result = await axios.get(`/saas/product-category/channels/get-categories-by-shop`, {
            params: {
              channelId: "WOO_COMMERCE_ID",
              channelShopId: shopId
            }
          });
          break;
        default:
          result = await axios.post(`/saas/shop/get-categories/`, {
            countryCode,
            channel: channelId,
            shopId
          });
          break;
      }
      setCategoriesList(result.data);
      return {categoriesList: result.data};
    } catch (error) {
      handleError(error);
      return {categoriesList: []};
    } finally {
      setIsLoading(false);
    }
  };
  return {
    isLoading,
    fetchData,
    categoriesList: CategoriesList
  };
};
export const useCategoriesModel = createModel(useCategories);
